module.exports = __webpack_public_path__ + "img/gallery.afedd29f.png";